import { getQueryString } from '../utils/tools.js';

let userCenterPath = window.location.origin;
const authLogin = () => {
    let redirectUrl = `${window.location.origin}${window.location.pathname}`;
    let loginUrl = `${userCenterPath}/api/auth/login?access_token=${getQueryString(
        "access_token"
    )}&redirect_url=${redirectUrl}`;
    return loginUrl;
};
const authLogout = () => {
    return `${userCenterPath}/api/auth/logout?redirect_url=${authLogin()}`;
};

export default {
    /* 鉴权模块 */
    // 登录
    'AUTH_LOGIN': authLogin,
    // 注销
    'AUTH_LOGOUT': authLogout,
    // 统一后台地址
    'UNIFY_BACKENDS': 'https://shield.seeronnet.com/#/basic/get_backend',
    // 登录（内部系统账号体系）
    'AUTH_USER_LOGIN': '/api/auth/userlogin',
    // 注销（内部系统账号体系）
    'AUTH_USER_LOGOUT': '/api/auth/userlogout',
    // 修改密码（内部系统账号体系）
    'AUTH_RESET_PSW': '/api/auth/resetpsw',
    // 用户管理
    'AUTH_USER': '/api/auth/user',
    // 权限管理
    'AUTH_ROLE': '/api/auth/role',
    // 获取用户信息
    'AUTH_GET_CUR_USER': '/api/auth/getCurUser',
    // 权限树
    'GET_AUTH_TREE': '/api/auth/pointsTree',
    // 权限点
    'HANDLER_AUTHPOINT': '/api/auth/points',
    // 操作日志
    'HANDLER_ACTION_LOG': '/api/auth/action_log',

    // 上传
    'UPLOAD_FILES': '/api/upload',
    // 图床的列表
    'GET_IMAGE_LIST': '/api/upload/list',
    // 微信文章采集
    'WEIXIN_COLLECT': '/api/wxcollect',

    'GET_DEMO': '/api/demo',
    // 组件
    'HANDLER_COMP': '/api/comp',
    // 组件发布
    'PUB_COMP': '/api/comp/pub',
    // 在线测算项目
    'HANDLER_ZXCSPJ': '/api/zxcspj',
    // 生成项目配置
    'GENERATE_PJCF': '/api/pjconfig/generate',
    // 数据元件接口
    'HANDLER_EDITOR_BASE': '/api/editorBase',
    // 数据套件接口
    'HANDLER_EDITOR_UNIT': '/api/editorUnit',
    // 页面模板接口
    'HANDLER_TEMP_PAGE': '/api/tempPage',
    // 页面模板发布
    'PUB_TEMP_PAGE': '/api/tempPage/pub',
    // 模板项目管理接口
    'HANDLER_TEMP_PROJECT': '/api/tempProject',
    // 项目管理接口
    'HANDLER_PROJECT': '/api/project',
    // 依模板新增项目
    'ADD_PROJECT_BY_TEMP': '/api/addProjectByTemp',
    // 刷新项目模板
    'REFRESH_TEMP_PROJECT': '/api/tempProject/refresh',
    // 图文列表项
    'HANDLER_IMG_ITEM': '/api/base/imgItem',

    // 活动页面模板
    'HANDLER_ACT_TEMP': '/api/acttemp',
    // 活动页面子项目
    'HANDLER_ACT_TEMP_SUB': '/api/acttempsub',
    // 同步数据配置到子项目
    'SYNC_ACT_TEMP': '/api/acttemp/sync',
    // 依活动模板新增项目
    'ADD_PROJECT_BY_ACT_TEMP': '/api/addProjectByActTemp',
    // 子项目同步数据配置
    'SYNC_ACT_TEMP_SUB': '/api/acttempsub/sync',

    // 获取渠道数据
    'GET_DIM_CHANNELS': '/api/dimension/channels',
    // 获取渠道组数据
    'CHANNEL_GROUPS': '/api/dimension/channelgroups',

    // 历史记录
    'HANDLER_HISTORY': '/api/history',
}



// WEBPACK FOOTER //
// ./src/service/apiPath.js